import ImportProcessWizard from './components/ImportProcessWizard'

const ImportProcessPage = () => {
  return <ImportProcessWizard />
}

export default ImportProcessPage
